export var IInstrumentTypeEnum;
(function (IInstrumentTypeEnum) {
    let InstrumentType;
    (function (InstrumentType) {
        InstrumentType["UNKNOWN"] = "UNKNOWN";
        InstrumentType["CHECKING_BANK_ACCOUNT"] = "CHECKING_BANK_ACCOUNT";
        InstrumentType["SAVINGS_BANK_ACCOUNT"] = "SAVINGS_BANK_ACCOUNT";
        InstrumentType["DEBIT_CARD"] = "DEBIT_CARD";
        InstrumentType["CREDIT_CARD"] = "CREDIT_CARD";
        InstrumentType["PREPAID_CARD"] = "PREPAID_CARD";
        InstrumentType["CHEQUE"] = "CHEQUE";
        InstrumentType["PLAID_AUTHORIZATION"] = "PLAID_AUTHORIZATION";
        InstrumentType["DEBIT_OR_CREDIT_CARD"] = "DEBIT_OR_CREDIT_CARD";
        InstrumentType["SEPA"] = "SEPA";
        InstrumentType["SOFORT"] = "SOFORT";
        InstrumentType["IDEAL"] = "IDEAL";
        InstrumentType["BACS"] = "BACS";
        InstrumentType["FAIRE_PAY"] = "FAIRE_PAY";
    })(InstrumentType = IInstrumentTypeEnum.InstrumentType || (IInstrumentTypeEnum.InstrumentType = {}));
    /**
     * Return an instance of IInstrumentTypeEnum with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IInstrumentTypeEnum.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IInstrumentTypeEnum || (IInstrumentTypeEnum = {}));
